/**
 * Created by matthew on 29/7/19.
 */
(function ($) {
	
	$.fn.pagination = function () {
		
		var form           = $(this),
		    trigger        = form.find('input[type="submit"]'),
		    paginationData = {};
		
		var init          = function () {
			
			    console.log('Pagination Ready...', form);
			
			    var paginationInputs = form.find('input[type="hidden"]');
			
			    trigger.on('click', function (event) {
				
				    event.preventDefault();
				
				    $.each(paginationInputs, function () {
					
					    console.log($(this).attr('name'), $(this).val());
					
					    paginationData[$(this).attr('name')] = $(this).val();
					
				    });
				
				    loadPosts(paginationData, function () {
					
					    updateHistory();
					
				    });
				
			    });
			
			
		    },
		    loadPosts     = function (paginationData) {
			
			    $.ajax({
				    url:      ajax_variables.ajax_url,
				    method:   'POST',
				    data:     {
					    action: 'gtek_load_posts',
					    data:   paginationData
				    },
				    success:  function (data) {
					
					    data = JSON.parse(data);
					    
					    console.log(data);
					    trigger.parents('.section__button').before(data.posts);
					    
					    var newPodcasts = data.posts;
					    
					    $('.section').find($('.injected-post')).fadeIn({
						    'duration': '350',
						    'start':    function () {
							    $(this).css('display', 'flex');
						    }
					    });
					
					    $('input[name="offset"]').val(data.offset);
					    
					    if(data.total_posts <= data.offset){
						    
						    trigger.hide();
						    
					    }
					    
					
				    }
			    })
			
		    },
		    updateHistory = function () {
			
		    };
		
		init();
		
		return this;
		
	}
	
})(jQuery);